import {
  Card,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Button,
  message,
  Tabs,
  Upload,
  notification
} from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { isCursorAtStart } from '@testing-library/user-event/dist/utils'
import Cookies from 'js-cookie'
import { get_v10_url } from '../utils/commonUtilities'
import { logout } from '../actions/authActions'
import { connect } from 'react-redux'
import { UploadOutlined, ArrowLeftOutlined, DownloadOutlined, EyeOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Country, State, City } from 'country-state-city'
import Lottie from 'lottie-react'
import SuccessAnimation from '../Assets/animations/checked-circle-animation.json'
import ViewPdfModal from '../Components/ViewPdfModal'
import GlobalLoader from '../Components/GlobalLoader'

function HospitalDetailsModal (props) {
  // console.warn("hospital modal: ",props)
  const [pdfUrl, setPdfUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [modalState, setModalState] = useState(true)
  const [successModal, setSuccessModal] = useState(false)
  const [tabNo, setTabNo] = useState('1')
  const [otherDocuments, setOtherDocuments] = useState([])
  const [addDoc, setAddDoc] = useState({
    docName: '',
    docURL: '',
  })
  const [fileList, setFileList] = useState([])
  const [generalInfo, setGeneralInfo] = useState({
    hospitalType: '',
    careType: '',
    ppnStatus: '',
    hospitalName: '',
    address: '',
    // place: '',
    state: '',
    city: '',
    pinCode: '',
    alternateNumber: '',
    mobileNumber: '',
    email: '',
    medicalSuperintendent: '',
    tpaHead: '',
    hospitalRegistrationNo: '',
    registrationAuthority: '',
    rohiniCode: '',
    hospitalPAN: '',
    panHolderName: '',
    cancelledCheque: '',
    hospitalRohini: '',
    regCertificated: '',
    tarrifList: '',
    panCard: '',
    gstCertificate: '',
  })

  const [basicInformation, setBasicInformation] = useState({
    impatientBeds: '',
    dayCarebeds: '',
    icuBeds: ''
  })

  const [accountInformation, setAccountInformation] = useState({
    accountNo: '',
    ifscCode: '',
    branchAddress: '',
    contactNo: ''
  })

  const country = Country.getCountryByCode('IN')
  
  const [statesList, setStatesList] = useState([])
  const [stateISO, setStateISO] = useState('')
  const [citiesList, setCitiesList] = useState([])
  
  useEffect(() => {
    const state = State.getStatesOfCountry(country.isoCode)
    // console.warn(states);
    let stateArray = []
    if(state.length > 0) {
      state.map(item => {
        stateArray.push({
          label: item.name,
          value: item.name,
          isoCode: item.isoCode
        })
      })
    }
    setStatesList(stateArray)
  }, [])

  const handleSelectedState = (value, option) => {
    setGeneralInfo({...generalInfo, state: value, city: ''})
    setStateISO(option?.isoCode)
  }

  useEffect(() => {
    const city = City.getCitiesOfState('IN',stateISO)
    // console.warn(city);
    let citiesArray = []
    if(stateISO === 'MP') {
      citiesArray.push({
        label: 'Barwaha',
        value: 'Barwaha'
      })
    }
    if(city.length > 0) {
      city.map(item => {
        citiesArray.push({
          label: item.name,
          value: item.name
        })
      })
    }
    setCitiesList(citiesArray)
  }, [stateISO])

  useEffect(() => {
    console.log(props.hospitalData);
    if (props.hospitalData) {
      setGeneralInfo({
        ...generalInfo,
        hospitalName: props.hospitalData.name ?? "",
        address: props.hospitalData.address ?? "",
        mobileNumber: props.hospitalData.mobileNumber ?? "",
        email: props.hospitalData.email ?? "",
        hospitalRegistrationNo: props.hospitalData.registrationNumber ?? "",
        careType: props.hospitalData.careType ?? "",
        state: props.hospitalData.state ?? "",
        city: props.hospitalData.city ?? "",
        pinCode: props.hospitalData.pinCode ?? "",
        rohiniCode: props.hospitalData.rohiniID ?? "",
        hospitalPAN: props.hospitalData.panNumber ?? "",
        panHolderName: props.hospitalData.bankDetails?.name ?? "",
        cancelledCheque: props.hospitalData.profileDocuments?.cancelledCheque ?? "",
        hospitalRohini: props.hospitalData.profileDocuments?.hospitalRohini ?? "",
        regCertificated: props.hospitalData.profileDocuments?.regCertificated ?? "",
        tarrifList: props.hospitalData.profileDocuments?.tarrifList ?? "",
        panCard: props.hospitalData.panCard ?? "",
        gstCertificate: props.hospitalData.profileDocuments?.gstCertificate ?? "",
        // otherDocuments: props.hospitalData.profileDocuments?.otherDocuments ?? [],
        ppnStatus: props.hospitalData.ppnStatus ?? "",
        registrationAuthority: props.hospitalData.registrationAuthority ?? "",
        alternateNumber: props.hospitalData.alternateNumber ?? "",
        hospitalType: props.hospitalData.hospitalType===true ? "Multi Speciality" : props.hospitalData.hospitalType===false ? 'Single Speciality' : '',
        medicalSuperintendent: props.hospitalData.medicalSuperintendent ?? "",
        tpaHead: props.hospitalData.tpaHead ?? "",
        representativeName: props.representativeName ?? "",
        representativeDesignation: props.representativeDesignation ?? "",
        termsChecked: props.hospitalData.termsChecked ?? false
      })
      setBasicInformation({
        ...basicInformation,
        icuBeds: props.hospitalData.bedsDetails?.icuBeds ?? "",
        impatientBeds: props.hospitalData.bedsDetails?.inPatientBeds ?? "",
        dayCarebeds: props.hospitalData.bedsDetails?.dayCareBeds ?? "",
      })
      setAccountInformation({
        ...accountInformation,
        accountNo: props.hospitalData.bankDetails?.accountNumber ?? "",
        ifscCode: props.hospitalData.bankDetails?.ifscCode ?? "",
        branchAddress: props.hospitalData.bankDetails?.branchAddress ?? "",
        contactNo: props.hospitalData.bankDetails?.accountContactNumber ?? "",
      })
      if(props.hospitalData.profileDocuments?.otherDocuments) {
        setOtherDocuments(props.hospitalData.profileDocuments?.otherDocuments)
      }
    }
  }, [props.hospitalData])

  const checkForEmptyField = (obj, excludeKeys = []) => {
    for (let [key, value] of Object.entries(obj)) {
        if (value === '' && !excludeKeys.includes(key)) {
            return { isEmpty: true, emptyKey: key };
        }
    }
    return { isEmpty: false, emptyKey: '' };
  }

  const handleSaveData = async () => {
    
    if(generalInfo.cancelledCheque==='') {
      message.error("Please upload cancelled cheque before saving the data")
      return
    }

    if(generalInfo.tarrifList==='') {
      message.error("Please upload TARIFF list before saving the data")
      return
    }

    if(generalInfo.hospitalRohini==='') {
      message.error("Please upload ROHINI before saving the data")
      return
    }

    if(generalInfo.regCertificated==='') {
      message.error("Please upload registration certificate before saving the data")
      return
    }

    if(generalInfo.panCard==='') {
      message.error("Please upload PAN card before saving the data")
      return
    }

    if(generalInfo.gstCertificate==='') {
      message.error("Please upload GST certificate before saving the data")
      return
    }

    const headers = {
      headers: { Authorization: `Bearer ${Cookies.get('token_medical_auth')}` }
    }

    try {
      setLoading(true)
      const response = await axios.post(
        `${get_v10_url()}/professional/updateHospitalInfo`,
        { ...generalInfo, ...basicInformation, ...accountInformation, firstLogin: true, representativeName: props.representativeName, representativeDesignation: props.representativeDesignation, othersDocuments: otherDocuments },
        headers
      )
      if (response.status === 200) {
        if (response.data.success) {
          message.success('Data Uploaded Successfully')
          setModalState(false)
          // window.location.reload()
          setSuccessModal(true)
          setLoading(false)
        }
      } else {
        console.error('DATA NOT POST')
        setLoading(false)
      }
    } catch (error) {
      console.error('ERROR POSTING DATA: ', error)
      setLoading(false)
    }
  }

  const uploadCancelledChequeProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadCancelledCheque`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, cancelledCheque: resBooking.docURL})
        message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, cancelledCheque: props.hospitalData.profileDocuments?.cancelledCheque ?? "" });
    },
    maxCount: 1,
  }

  const uploadPanCardProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadPanCard`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, panCard: resBooking.docURL})
        message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, panCard: props.hospitalData.panCard ?? "" });
    },
    maxCount: 1,
  }

  const uploadGstCertificateProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadGstCertificate`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, gstCertificate: resBooking.docURL})
        message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, gstCertificate: props.hospitalData.profileDocuments?.gstCertificate ?? "" });
    },
    maxCount: 1,
  }

  const uploadOtherDocumentProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalDocument`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      console.log(info);
      setFileList(info.fileList)
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setAddDoc({...addDoc, docURL: resBooking.docURL})
        message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setAddDoc({...addDoc, docURL: ''})
    },
    fileList: fileList,
    maxCount: 1,
  }

  const uploadHospitalRohini = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalRohini`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, hospitalRohini: resBooking.docURL})
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, hospitalRohini: props.hospitalData.profileDocuments?.hospitalRohini ?? "" });
    },
    maxCount: 1,
  }

  const uploadRegistrationCertificate = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadRegistrationCertificate`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, regCertificated: resBooking.docURL})
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, regCertificated: props.hospitalData.profileDocuments?.regCertificated ?? "" });
    },
    maxCount: 1,
  }

  const uploadTarriffList = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadTarriffList`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, tarrifList: resBooking.docURL})
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, tarrifList: props.hospitalData.profileDocuments?.tarrifList ?? "" });
    },
    maxCount: 1,
  }

  const handleNext = () => {
    if(tabNo==='1') {
      handleSetpageNo2()
    }
    else if (tabNo==='2') {
      handleSetpageNo3()
    }
    else if (tabNo==='3') {
      handleSaveData()
    }
  }

  const handleAddNewDoc = () => {
    if(!addDoc.docName || !addDoc.docURL) {
        notification.error({
            message: "Error",
            description: "Please enter document name and upload the document before adding."
        })
        return
    }
    otherDocuments.push({
        docName: addDoc.docName,
        docURL: addDoc.docURL,
    })
    setAddDoc({docName: '', docURL: ''})
    setFileList([])
  }

  const handleDeleteDoc = (name, url) => {
      const updtaedDoc = [...otherDocuments].filter(doc => doc.docURL !== url)
      setOtherDocuments(updtaedDoc)
  }

  const handleSetpageNo2 = () => {
    const excludeKeys = ['alternateNumber','cancelledCheque','hospitalRohini','regCertificated', 'tarrifList', 'panCard', 'gstCertificate'];
    const isGeneralEmpty = checkForEmptyField(generalInfo, excludeKeys)
    // console.log("HERE>>>>>>>> ", isGeneralEmpty);
    // console.log("INFO>>>>>>>> ", generalInfo);
    if(isGeneralEmpty.isEmpty) {
      if(isGeneralEmpty.emptyKey === 'hospitalType') {
        message.error('Please enter type of hospital before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'careType') {
        message.error('Please enter type of care before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'ppnStatus') {
        message.error('Please enter PPN status before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalName') {
        message.error('Please enter name of hospital before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'address') {
        message.error('Please enter address before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'state') {
        message.error('Please enter state before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'city') {
        message.error('Please enter city before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'pinCode') {
        message.error('Please enter PIN code before saving the data.')
        return
      }
      // if(isGeneralEmpty.emptyKey === 'alternateNumber') {
      //   message.error('Please enter phone number before saving the data.')
      //   return
      // }
      if(isGeneralEmpty.emptyKey === 'mobileNumber') {
        message.error('Please enter mobile number before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'email') {
        message.error('Please enter email before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'medicalSuperintendent') {
        message.error('Please enter medical superintendent before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'tpaHead') {
        message.error('Please enter TPA head before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalRegistrationNo') {
        message.error('Please enter hospital registration number before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'registrationAuthority') {
        message.error('Please enter registering authority before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'rohiniCode') {
        message.error('Please enter ROHINI code before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalPAN') {
        message.error('Please enter hospital PAN before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'panHolderName') {
        message.error('Please enter account holder name before saving the data.')
        return
      }
    }
    if(generalInfo.alternateNumber !== '' && generalInfo.alternateNumber !== undefined && generalInfo.alternateNumber !== null && generalInfo.alternateNumber?.length !== 10) {
      message.error('Please enter a 10-digits alternate number before saving the data.')
      return
    }
    if(generalInfo.mobileNumber?.length !== 10) {
      message.error('Please enter a 10-digits mobile number before saving the data.')
      return
    }
    if(generalInfo.pinCode?.length < 6) {
      message.error('PIN Code cannot be less than 6-digits')
      return
    }
    if(generalInfo.email !== '' && generalInfo.email !== undefined && generalInfo.email !== null) {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!emailRegex.test(generalInfo.email)) {
        message.error('Please enter a valid email address')
      }
    }
    setTabNo('2')
  }

  const handleSetpageNo3 = () => {
    const excludeKeys = ['alternateNumber','cancelledCheque','hospitalRohini','regCertificated', 'tarrifList', 'panCard', 'gstCertificate'];
    const isGeneralEmpty = checkForEmptyField(generalInfo, excludeKeys)
    const isBasicEmpty = checkForEmptyField(basicInformation)
    const isAccountEmpty = checkForEmptyField(accountInformation)
    if(isGeneralEmpty.isEmpty) {
      if(isGeneralEmpty.emptyKey === 'hospitalType') {
        message.error('Please enter type of hospital before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'careType') {
        message.error('Please enter type of care before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'ppnStatus') {
        message.error('Please enter PPN status before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalName') {
        message.error('Please enter name of hospital before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'address') {
        message.error('Please enter address before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'state') {
        message.error('Please enter state before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'city') {
        message.error('Please enter city before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'pinCode') {
        message.error('Please enter PIN code before saving the data.')
        return
      }
      // if(isGeneralEmpty.emptyKey === 'phoneNo') {
      //   message.error('Please enter phone number before saving the data.')
      //   return
      // }
      if(isGeneralEmpty.emptyKey === 'mobileNo') {
        message.error('Please enter mobile number before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'email') {
        message.error('Please enter email before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'medicalSuperintendent') {
        message.error('Please enter medical superintendent before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'tpaHead') {
        message.error('Please enter TPA head before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalRegistrationNo') {
        message.error('Please enter hospital registration number before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'registrationAuthority') {
        message.error('Please enter registering authority before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'rohiniCode') {
        message.error('Please enter ROHINI code before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'hospitalPAN') {
        message.error('Please enter hospital PAN before saving the data.')
        return
      }
      if(isGeneralEmpty.emptyKey === 'panHolderName') {
        message.error('Please enter PAN holder name before saving the data.')
        return
      }
    }
    // if(generalInfo.phoneNo.length !== 10) {
    //   message.error('Please enter a 10-digit phone number before saving the data.')
    //   return
    // }
    if(generalInfo.pinCode?.length < 6) {
      message.error('Please enter a 6 digits PIN Code')
      return
    }
    if(basicInformation.impatientBeds < 0) {
      message.error('Inpatient beds cannot be negative')
      return
    }
    if(basicInformation.dayCarebeds < 0) {
      message.error('Day care beds cannot be negative')
      return
    }
    if(basicInformation.icuBeds < 0) {
      message.error('ICU beds cannot be negative')
      return
    }
    if(isBasicEmpty.isEmpty) {
      if(isBasicEmpty.emptyKey === 'impatientBeds') {
        message.error('Please enter inpatient beds before saving the data.')
        return
      }
      if(isBasicEmpty.emptyKey === 'dayCarebeds') {
        message.error('Please enter day care beds before saving the data.')
        return
      }
      if(isBasicEmpty.emptyKey === 'icuBeds') {
        message.error('Please enter ICU beds before saving the data.')
        return
      }
    }
    if(isAccountEmpty.isEmpty) {
      if(isAccountEmpty.emptyKey === 'accountNo') {
        message.error('Please enter account number before saving the data.')
        return
      }
      if(isAccountEmpty.emptyKey === 'ifscCode') {
        message.error('Please enter IFSC code before saving the data.')
        return
      }
      if(isAccountEmpty.emptyKey === 'branchAddress') {
        message.error('Please enter branch address before saving the data.')
        return
      }
      if(isAccountEmpty.emptyKey === 'contactNo') {
        message.error('Please enter contact number before saving the data.')
        return
      }
    }
    if(accountInformation.contactNo.length !== 10) {
      message.error('Please enter 10-digit contact number before saving the data.')
      return
    }
    setTabNo('3')
  }

  return (
    <>
    <Modal
      title={
        <>
          <span className='title'>Hospital Details {tabNo}/3</span>{' '}
          <Button
            className='logout-btn-hospital'
            onClick={() => {
              props.logout()
              window.location.href = '/auth'
            }}
          >
            Log out
          </Button>
        </>
      }
      open={modalState}
      width={'80%'}
      className='hospital-details-modal'
      closable={false}
    >
      <Tabs activeKey={tabNo} defaultActiveKey='1'>
        <Tabs.TabPane
          key='1'
          tab={
            <span
              className={tabNo === '1' ? 'selected' : ''}
              onClick={() => setTabNo('1')}
            >
              General Information
            </span>
          }
          active={tabNo === '1'}
        >
          <Row gutter={24}>
            <Col span={8}>
              <label>Type of Hospital*</label>
              <Select
                type='select'
                options={[
                  {
                    label: 'Single Speciality',
                    value: 'Single Speciality'
                  },
                  {
                    label: 'Multi Speciality',
                    value: 'Multi Speciality'
                  }
                ]}
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, hospitalType: e })
                }
                name='insurance'
                value={generalInfo.hospitalType || undefined}
                placeholder='Choose Hospital Type'
                className='booking-dropdown-container details-selection-input'
                style={{ width: '100%' }}
                isMulti={false}
                blurInputOnSelect={true}
                closeMenuOnSelect={true}
                getPopupContainer={trigger => trigger.parentElement}
              />
            </Col>
            <Col span={8}>
              <label>Type of Care*</label>
              <Select
                type='select'
                options={[
                  {
                    label: 'Primary Care',
                    value: 'Primary Care'
                  },
                  {
                    label: 'Secondary Care',
                    value: 'Secondary Care'
                  },
                  {
                    label: 'Tertiary Care',
                    value: 'Tertiary Care'
                  }
                ]}
                onChange={e => setGeneralInfo({ ...generalInfo, careType: e })}
                name='careType'
                value={generalInfo.careType || undefined}
                placeholder='Choose Care Type'
                className='booking-dropdown-container details-selection-input'
                style={{ width: '100%' }}
                isMulti={false}
                blurInputOnSelect={true}
                closeMenuOnSelect={true}
                getPopupContainer={trigger => trigger.parentElement}
              />
            </Col>
            <Col span={8}>
              <label>PPN Status*</label>
              <Select
                type='select'
                options={[
                  {
                    label: 'PPN',
                    value: 'PPN'
                  },
                  {
                    label: 'Non-PPN',
                    value: 'Non-PPN'
                  }
                ]}
                onChange={e => setGeneralInfo({ ...generalInfo, ppnStatus: e })}
                name='ppnStatus'
                value={generalInfo.ppnStatus || undefined}
                placeholder='Choose PPN Status'
                className='booking-dropdown-container details-selection-input'
                style={{ width: '100%' }}
                isMulti={false}
                blurInputOnSelect={true}
                closeMenuOnSelect={true}
                getPopupContainer={trigger => trigger.parentElement}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <label>Hospital Name*</label>
              <Input
                disabled
                value={generalInfo.hospitalName}
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    hospitalName: e.target.value
                  })
                }
                style={{ width: '100%' }}
              />
            </Col>
            <Col span={6}>
              <label>State*</label>
              {/* <Input
                value={generalInfo.state}
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, state: e.target.value })
                }
                style={{ width: '100%' }}
              /> */}
              {/* {console.warn(statesList)} */}
              {statesList && <Select
                type='select'
                value={generalInfo.state || undefined}
                placeholder='Select state'
                isMulti={false}
                onChange={handleSelectedState}
                style={{width: '100%'}}
                className='booking-dropdown-container details-selection-input'
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(opA, opB) => 
                  (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                }
                getPopupContainer={trigger => trigger.parentElement}
              >
                {statesList.map(state => (
                  <Select.Option value={state.value} isoCode={state.isoCode}>
                    {state.label}
                  </Select.Option>
                ))}
              </Select>}
            </Col>
            <Col span={6}>
              <label>City*</label>
              {(citiesList.length===0 && generalInfo.city==='') ? <Input
                value={"Please select state first"}
                disabled={true}
                style={{ width: '100%' }}
              /> :
              <Select
                type='select'
                options={citiesList}
                value={generalInfo.city || undefined}
                placeholder='Select city'
                onChange={e => setGeneralInfo({...generalInfo, city: e})}
                isMulti={false}
                style={{ width: '100%' }}
                className='booking-dropdown-container details-selection-input'
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(opA, opB) => 
                  (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                }
                getPopupContainer={trigger => trigger.parentElement}
              />}
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <label>Address*</label>
              <Input
                value={generalInfo.address}
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, address: e.target.value })
                }
                style={{ width: '100%' }}
                placeholder='Enter Address'
              />
            </Col>
            <Col span={6}>
              <label>PIN Code*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, pinCode: e.target.value })
                }
                style={{ width: '100%' }}
                placeholder='Enter PIN Code'
                value={generalInfo.pinCode}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <label>Alternate No.</label>
              <Input
                type='number'
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, alternateNumber: e.target.value })
                }
                style={{ width: '100%' }}
                placeholder='Enter Phone Number'
                value={generalInfo.alternateNumber}
              />
            </Col>
            <Col span={8}>
              <label>Mobile No.*</label>
              <Input
                disabled
                value={generalInfo.mobileNumber}
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, mobileNumber: e.target.value })
                }
                style={{ width: '100%' }}
              />
            </Col>
            <Col span={8}>
              <label>Email*</label>
              <Input
                disabled
                value={generalInfo.email}
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, email: e.target.value })
                }
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <label>Medical Superintendent*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    medicalSuperintendent: e.target.value
                  })
                }
                style={{ width: '100%' }}
                placeholder='Enter Medical Superintendent'
                value={generalInfo.medicalSuperintendent}
              />
            </Col>
            <Col span={8}>
              <label>Marketing/TPA Head*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, tpaHead: e.target.value })
                }
                style={{ width: '100%' }}
                placeholder='Enter Marketing/TPA Head'
                value={generalInfo.tpaHead}
              />
            </Col>
            <Col span={8}>
              <label>Hospital Registration No.*</label>
              <Input
                value={generalInfo.hospitalRegistrationNo}
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    hospitalRegistrationNo: e.target.value
                  })
                }
                style={{ width: '100%' }}
                placeholder='Hospital Registration No.'
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <label>Registering Authority*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    registrationAuthority: e.target.value
                  })
                }
                style={{ width: '100%' }}
                placeholder='Enter Registering Authority'
                value={generalInfo.registrationAuthority}
              />
            </Col>
            <Col span={8}>
              <label>ROHINI Code*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({ ...generalInfo, rohiniCode: e.target.value })
                }
                style={{ width: '100%' }}
                placeholder='Enter ROHINI Code'
                value={generalInfo.rohiniCode}
              />
            </Col>
            <Col span={8}>
              <label>PAN Number of Hospital*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    hospitalPAN: e.target.value
                  })
                }
                style={{ width: '100%' }}
                placeholder='Enter PAN Number of Hospital'
                value={generalInfo.hospitalPAN}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <label>Account Holder Name*</label>
              <Input
                onChange={e =>
                  setGeneralInfo({
                    ...generalInfo,
                    panHolderName: e.target.value
                  })
                }
                style={{ width: '100%' }}
                placeholder='Enter Account Holder Name'
                value={generalInfo.panHolderName}
              />
            </Col>
          </Row>
        </Tabs.TabPane>

        <Tabs.TabPane
          key='2'
          tab={
            <span
              className={tabNo === '2' ? 'selected' : ''}
              onClick={handleSetpageNo2}
            >
              Basic & Account Information
            </span>
          }
          active={tabNo === '2'}
        >
          <div className='banner'>Basic Information</div>
          <Row gutter={24}>
            <Col span={8}>
              <label>Number of Inpatient Beds*</label>
              <Input
                type='number'
                onChange={e =>
                  setBasicInformation({
                    ...basicInformation,
                    impatientBeds: e.target.value
                  })
                }
                placeholder='Enter Number of Inpatient Beds'
                value={basicInformation.impatientBeds}
              />
            </Col>
            <Col span={8}>
              <label>Number of Day Care Beds*</label>
              <Input
                type='number'
                onChange={e =>
                  setBasicInformation({
                    ...basicInformation,
                    dayCarebeds: e.target.value
                  })
                }
                placeholder='Enter Number of Day Care Beds'
                value={basicInformation.dayCarebeds}
              />
            </Col>
            <Col span={8}>
              <label>Number of ICU Beds*</label>
              <Input
                type='number'
                onChange={e =>
                  setBasicInformation({
                    ...basicInformation,
                    icuBeds: e.target.value
                  })
                }
                placeholder='Enter Number of ICU Beds'
                value={basicInformation.icuBeds}
              />
            </Col>
          </Row>
          <div className='banner'>Bank Account Details</div>
          <Row gutter={24}>
            <Col span={12}>
              <label>Bank Account Number*</label>
              <Input
                onChange={e =>
                  setAccountInformation({
                    ...accountInformation,
                    accountNo: e.target.value
                  })
                }
                placeholder='Enter Account Number'
                value={accountInformation.accountNo}
              />
            </Col>
            <Col span={12}>
              <label>IFSC Code*</label>
              <Input
                onChange={e =>
                  setAccountInformation({
                    ...accountInformation,
                    ifscCode: e.target.value
                  })
                }
                placeholder='Enter IFSC Code'
                value={accountInformation.ifscCode}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <label>Branch Address*</label>
              <Input
                onChange={e =>
                  setAccountInformation({
                    ...accountInformation,
                    branchAddress: e.target.value
                  })
                }
                placeholder='Enter Branch Address'
                value={accountInformation.branchAddress}
              />
            </Col>
            <Col span={12}>
              <label>Account Department Contact Number*</label>
              <Input
                onChange={e =>
                  setAccountInformation({
                    ...accountInformation,
                    contactNo: e.target.value
                  })
                }
                placeholder='Enter Account Department Contact Number'
                value={accountInformation.contactNo}
              />
            </Col>
          </Row>
        </Tabs.TabPane>

        <Tabs.TabPane
          key='3'
          tab={
            <span
              className={tabNo === '3' ? 'selected' : ''}
              onClick={handleSetpageNo3}
            >
              Documents
            </span>
          }
          active={tabNo === '3'}
        >
          <Row gutter={24}>
            <Col span={12}>
              {props.hospitalData.profileDocuments?.cancelledCheque && <a onClick={()=>{setPdfUrl(generalInfo.cancelledCheque)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View Cancelled Cheque <EyeOutlined/></a>}
              <Upload
                {...uploadCancelledChequeProps}
                // placeholder='Upload Cancelled Cheque'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.cancelledCheque ? 'Update' : 'Upload'} Cancelled Cheque*
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              {props.hospitalData.profileDocuments?.hospitalRohini && <a onClick={()=>{setPdfUrl(generalInfo.hospitalRohini)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View Hospital ROHINI <EyeOutlined/></a>}
              <Upload
                {...uploadHospitalRohini}
                // placeholder='Upload Hospital ROHINI'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.hospitalRohini ? 'Update' : 'Upload'} Hospital ROHINI*
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              {props.hospitalData.profileDocuments?.regCertificated && <a onClick={()=>{setPdfUrl(generalInfo.regCertificated)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View Registration Certificate <EyeOutlined/></a>}
              <Upload
                {...uploadRegistrationCertificate}
                // placeholder='Upload Registration Certificate'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.regCertificated ? 'Update' : 'Upload'} Registration Certificate*
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              {props.hospitalData.profileDocuments?.tarrifList && <a onClick={()=>{setPdfUrl(generalInfo.tarrifList)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View Tariff List <EyeOutlined/></a>}
              <Upload
                {...uploadTarriffList}
                // placeholder='Upload Tariff List'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.tarrifList ? 'Update' : 'Upload'} Tariff List*
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              {props.hospitalData?.panCard && <a onClick={()=>{setPdfUrl(generalInfo.panCard)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View PAN Card <EyeOutlined/></a>}
              <Upload
                {...uploadPanCardProps}
                // placeholder='Upload Registration Certificate'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.panCard ? 'Update' : 'Upload'} PAN Card*
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              {props.hospitalData.profileDocuments?.gstCertificate && <a onClick={()=>{setPdfUrl(generalInfo.gstCertificate)}} style={{color:'#04D0D9', fontSize:'1rem'}}>View GST Certificate <EyeOutlined/></a>}
              <Upload
                {...uploadGstCertificateProps}
                // placeholder='Upload Tariff List'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />}>
                  {generalInfo.gstCertificate ? 'Update' : 'Upload'} GST Certificate*
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
                <Input 
                  value={addDoc.docName} 
                  onChange={e => setAddDoc({...addDoc, docName: e.target.value})} 
                  placeholder="Enter document name"
                  style={{marginTop:'0'}}
                />
            </Col>
            <Col span={6}>
                <Upload {...uploadOtherDocumentProps}>
                  <Button icon={<UploadOutlined />}>
                    Upload Document
                  </Button>
                </Upload>
            </Col>
            <Col span={6}>
                <Button className="btn-primary" style={{fontSize: '1.25rem'}} onClick={() => handleAddNewDoc()}>Add</Button>
            </Col>
          </Row>
          {otherDocuments.length > 0 && <Row gutter={24}>
            <Col span={24}>
                <div style={{display:'flex', alignItems: 'center', gap:'1rem', flexWrap:'wrap'}}>
                    {otherDocuments.map(doc => (
                        <div style={{display:'flex', alignItems: 'center', gap: '3rem', border:'1px solid #666666', borderRadius:'8px', padding:'0.5rem 0.75rem'}}>
                            <a onClick={()=>setPdfUrl(doc.docURL)} style={{width: 'max-content', margin: '0'}}>{doc.docName}</a>
                            <CloseCircleOutlined style={{cursor: 'pointer', color:'#FE2222', fontSize:'18px'}} onClick={()=>handleDeleteDoc(doc.docName, doc.docURL)} />
                        </div>
                    ))}
                </div>
            </Col>
          </Row>}
        </Tabs.TabPane>
      </Tabs>

      <Row gutter={24} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '32px' }}>
        <Col span={8}>
          <Button className='btn-primary' onClick={handleNext}>
            {tabNo === '3' ? 'Submit' : 'Next'}
          </Button>
        </Col>
      </Row>
    </Modal>
    <Modal
      width={700}
      visible={successModal}
      className='success-modal'
      onCancel={()=>setSuccessModal(false)}
      onOk={()=>setSuccessModal(false)}
    >
      <h4>Details Successfully Submitted</h4>
      <p>You can now <a href='/dashboard/create-booking' style={{color:'#06BEC6', cursor:'pointer', textDecoration:'underline', textUnderlineOffset:'5px'}} onClick={()=>setSuccessModal(false)}>click here</a> to add patient details.</p>
      <div style={{display:'flex', alignItems:'center', justifyContent:'center', margin:'2rem 0'}}>
        <Lottie animationData={SuccessAnimation} style={{width:'400px', height:'400px'}}/>
      </div>
    </Modal>
    {pdfUrl && <ViewPdfModal openPDFModal={pdfUrl} pdfUrl={pdfUrl} setOpenPDFModal={setPdfUrl} />}
    {loading && <GlobalLoader/>}
    </>
  )
}

const mapStateToProps = state => ({
  user: state.authStore
})

export default connect(mapStateToProps, {
  logout
})(HospitalDetailsModal)
